import React from 'react';

import './first-screen.scss';

const FirstScreen = () => {
  return (
    <section className="first-screen">
      <picture>
        <source
          type="image/webp"
          srcSet={`${process.env.PUBLIC_URL}/images/header-background-mobile.webp, ${process.env.PUBLIC_URL}/images/header-background-mobile@2x.webp 2x`}
          media="(max-width: 500px)"
        />
        <source
          srcSet={`${process.env.PUBLIC_URL}/images/header-background-mobile.jpg, ${process.env.PUBLIC_URL}/images/header-background-mobile@2x.jpg 2x`}
          media="(max-width: 500px)"
        />
        <source
          type="image/webp"
          srcSet={`${process.env.PUBLIC_URL}/images/header-background.webp, ${process.env.PUBLIC_URL}/images/header-background@2x.webp 2x`}
        />
        <img
          src={`${process.env.PUBLIC_URL}/images/header-background.jpg`}
          srcSet={`${process.env.PUBLIC_URL}/images/header-background@2x.jpg 2x`}
          alt="Cemetery landscape"
          className="first-screen__background"
        ></img>
      </picture>
      <div className="first-screen__bg-opacity"></div>
      <div className="first-screen__section">
        <h1 className="first-screen__heading">לגבי השירות</h1>
        <p className="first-screen__text">
          חשוב לשמור על קשר עם השורשים שלנו
          <br />
          ולהעריך את המורשת שהשאירו לנו.
        </p>
      </div>
    </section>
  );
};

export default FirstScreen;
